<style lang="scss" scoped>
.top-container {
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;

    .button-container {
        .top-button {
            margin-right: 15px;
        }
    }
}

.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(180deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.error-bar {
    color: #fff;
    background-color: #ed4014;
    padding: 10px 15px;
    margin: 5px 0 15px 0;
    border-radius: 2px;
}
.table-margin {
    margin: 15px;
}
</style>
<template>
    <div>
        <div class="top-container">
            <!-- <div
                class="top-font font-weight"
                style="padding: 10px 0; margin-left: 15px; font-size: 14px"
            >
                {{
                    $t("erp.distribution.deliverorderno", {
                        defaultValue: "配货单号",
                    })
                }}：{{ formData.deliverOrderNo }}
            </div> -->
            <div class="button-container-left" v-if="type === 'query'">
                <Button
                    v-if="
                        formData.deliverOrderStatus == 0 ||
                        formData.deliverOrderStatus == 5 ||
                        formData.deliverOrderStatus == 1
                    "
                    type="primary"
                    @click="handleAlert('reset')"
                    >{{
                        $t("erp.disturibution.reset_order", {
                            defaultValue: "重置配货单",
                        })
                    }}
                </Button>
                <!-- <Button
                    class="light-content margin-left-15"
                    @click="addNotes"
                    >{{$t('erp.b2c.add_notes',{defaultValue:'添加备注'})}}
                </Button> -->
                <Button
                    type="warning"
                    class="margin-left-15"
                    v-if="formData.errorCode !== 0"
                    @click="handleAlert('backToNormal')"
                    >{{
                        $t("erp.b2c.back_normal", { defaultValue: "恢复正常" })
                    }}</Button
                >
                <!-- <Button
                    class="margin-left-15 light-primary"
                    type="success"
                    v-if="
                        contextId !== 1000147 &&
                        (formData.deliverOrderStatus === 0 ||
                            formData.deliverOrderStatus === 1)
                    "
                    @click="handleAlert('pushWarehouse')"
                    >{{
                        $t("erp.b2c.pushyuncang", { defaultValue: "推送仓库" })
                    }}</Button
                > -->
                <!-- <Button
                    class="margin-left-15"
                    type="primary"
                    v-if="formData.deliverOrderStatus === 1"
                    @click="handleAlert('pushAgain')"
                    >{{
                        $t("erp.distribution.repush", {
                            defaultValue: "附件重推",
                        })
                    }}</Button
                > -->
                <Button
                    class="margin-left-15"
                    type="success"
                    v-show="contextId == 1000147"
                    @click="pickup"
                    >Pickup</Button
                >
                <!-- <Button
                    class="margin-left-15"
                    type="warning"
                    @click="attachUpload"
                    >{{
                        $t("erp.b2c.arrachement_upload", {
                            defaultValue: "附件上传",
                        })
                    }}</Button
                > -->
                <!-- <Button
                    v-if="
                        formData.deliverOrderStatus == 0 &&
                        formData.errorCode == '00000'
                    "
                    class="margin-left-15"
                    type="info"
                    @click="handleAlert('resubmit')"
                    >{{
                        $t("global.common.resubmit", {
                            defaultValue: "重新提交",
                        })
                    }}</Button
                > -->
                <Button
                    v-if="
                        type == 'query' &&
                        (formData.activeStatus === 0 ||
                            formData.deliverOrderStatus === 5) &&
                        formData.labelStatus === 0
                    "
                    class="margin-left-15"
                    type="warning"
                    @click="editOrder"
                    >{{
                        $t("global.common.operation_edit", {
                            defaultValue: "编辑",
                        })
                    }}</Button
                >
                <Button
                    class="margin-left-15"
                    type="primary"
                    @click="manualBack"
                    >{{
                        $t("erp.b2c.manual_back", { defaultValue: "手动回传" })
                    }}</Button
                >
                <!-- <Button
                    v-if="
                        handleAuth('deliver.order.truckReservation') &&
                        formData.deliverOrderStatus == 1
                    "
                    class="margin-left-15"
                    type="primary"
                    @click="bookTruck"
                    >{{$t('fbb.transfer.truckreservation', { defaultValue: "卡车预约" }),}}</Button
                >
                <Button
                    v-if="
                        handleAuth('deliver.order.palletImport') &&
                        formData.deliverOrderStatus == 1
                    "
                    class="margin-left-15"
                    type="primary"
                    @click="importTrustInfo"
                    >{{$t('erp.b2c.import_trust_information', { defaultValue: "导入打托信息" }),}}</Button
                > -->
                <Button
                    v-if="
                        handleAuth('deliver.order.set') &&
                        formData.channelCategory === 'amazonvendor'
                    "
                    class="margin-left-15"
                    type="primary"
                    @click="exportAmzcc"
                    >{{
                        $t("erp.b2c.AMZCC_Export", {
                            defaultValue: "AMZCC导出",
                        })
                    }}</Button
                >
                <Button
                    v-if="
                        handleAuth('deliver.order.set') &&
                        formData.channelCategory === 'amazonvendor'
                    "
                    class="margin-left-15"
                    type="info"
                    @click="exportPoUpload"
                    >{{
                        $t("erp.b2c.PO_attachments", {
                            defaultValue: "PO附件上传",
                        })
                    }}</Button
                >
                <Button
                    v-if="
                        handleAuth('deliver.order.set') &&
                        formData.channelCategory === 'amazonvendor'
                    "
                    class="margin-left-15"
                    type="info"
                    @click="skuChangeLabel"
                    >{{
                        $t("erp.b2c.sku_change_label", {
                            defaultValue: "SKU换标",
                        })
                    }}</Button
                >
                <Dropdown trigger="hover" @on-click="handleMore">
                    <Button class="margin-left-15" type="primary">
                        {{
                            $t("global.common.operates", {
                                defaultValue: "更多操作",
                            })
                        }}
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem v-if="deliverset" name="addNotes">{{
                            $t("erp.b2c.add_notes", {
                                defaultValue: "添加备注",
                            })
                        }}</DropdownItem>
                        <DropdownItem
                            v-if="
                                contextId !== 1000147 &&
                                (formData.deliverOrderStatus === 0 ||
                                    formData.deliverOrderStatus === 5 ||
                                    formData.deliverOrderStatus === 1) &&
                                deliverset
                            "
                            name="pushWarehouse"
                            >{{
                                $t("erp.b2c.pushyuncang", {
                                    defaultValue: "推送仓库",
                                })
                            }}
                        </DropdownItem>
                        <DropdownItem
                            v-if="
                                formData.deliverOrderStatus === 1 && deliverset
                            "
                            name="pushAgain"
                            >{{
                                $t("erp.distribution.repush", {
                                    defaultValue: "附件重推",
                                })
                            }}
                        </DropdownItem>
                        <DropdownItem v-if="deliverset" name="attachUpload">
                            {{
                                $t("erp.b2c.arrachement_upload", {
                                    defaultValue: "附件上传",
                                })
                            }}
                        </DropdownItem>
                        <DropdownItem v-if="deliverBuyLabel" name="buyLabel">
                            {{
                                $t("erp.aftersales.buyfaceorder", {
                                    defaultValue: "购买面单",
                                })
                            }}
                        </DropdownItem>
                        <DropdownItem
                            v-if="
                                (formData.deliverOrderStatus == 0 ||
                                    formData.deliverOrderStatus === 5) &&
                                formData.errorCode == '00000'
                            "
                            name="resubmit"
                        >
                            {{
                                $t("global.common.resubmit", {
                                    defaultValue: "重新提交",
                                })
                            }}
                        </DropdownItem>
                        <DropdownItem
                            v-if="
                                (formData.deliverOrderStatus == 0 ||
                                    formData.deliverOrderStatus === 5 ||
                                    formData.deliverOrderStatus == 1) &&
                                delivercancel
                            "
                            name="cancel"
                        >
                            {{
                                $t("global.common.operate_cancel", {
                                    defaultValue: "取消",
                                })
                            }}
                        </DropdownItem>
                        <DropdownItem
                            v-if="
                                (formData.deliverOrderStatus === 5 ||
                                    formData.deliverOrderStatus === 0) &&
                                deliverset
                            "
                            name="batchChangeLastestTime"
                        >
                            {{
                                $t(
                                    "erp.distribution.batch_change_lastest_deliver_date",
                                    {
                                        defaultValue: "修改最晚发货时间",
                                    }
                                )
                            }}
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
            <div class="button-container-right" v-if="type === 'query'">
                <Button
                    v-if="type == 'query'"
                    class="margin-left-15"
                    type="primary"
                    @click="refresh"
                    >{{
                        $t("global.common.refresh", { defaultValue: "刷新" })
                    }}</Button
                >
            </div>
        </div>
        <div
            v-if="formData.errorCode !== 0 && type == 'query'"
            class="error-bar"
        >
            {{
                `${$t("erp.b2c.abnormal_order", {
                    defaultValue: "异常订单",
                })} ${getError()}`
            }}
        </div>
        <compWrapper
            :title="
                $t('global.common.base_information', {
                    defaultValue: '基本信息',
                })
            "
            theme="primary"
        >
            <compFormQuery
                class="margin-right-15 margin-top-15"
                :formdata="getBase"
                :value="formData"
                placeholder="--"
            ></compFormQuery>
            <template v-if="type != 'query'" slot="footer">
                <vButton class="margin-right-20" theme="info" @click="submit">{{
                    $t("global.common.save", { defaultValue: "保存" })
                }}</vButton>
                <vButton class="margin-right-20" @click="cancel">{{
                    $t("global.common.operation_cancel", {
                        defaultValue: "取消",
                    })
                }}</vButton>
            </template>
        </compWrapper>
        <compWrapper
            v-if="handleAuth('erp.b2cOrder.address')"
            :title="
                $t('erp.b2c.receiving_information', {
                    defaultValue: '收货信息',
                })
            "
            theme="info"
        >
            <compFormQuery
                v-if="type === 'query'"
                class="margin-right-15 margin-top-15"
                :formdata="getRecive"
                :value="formData"
                placeholder="--"
            ></compFormQuery>
            <compFormEdit
                v-else
                ref="tableEdit1"
                class="margin-right-15 margin-top-15"
                v-model="formData"
                :formdata="getRecive"
            ></compFormEdit>
        </compWrapper>
        <compWrapper
            :title="
                $t('erp.b2c.product_information', { defaultValue: '产品信息' })
            "
            theme="info"
        >
            <Table
                class="table-margin"
                :columns="columns"
                :data="dataList"
                size="small"
                ref="table"
                border
                stripe
            ></Table>
        </compWrapper>
        <compWrapper
            :title="
                $t('erp.b2c.logistics_information', {
                    defaultValue: '仓库物流信息',
                })
            "
            theme="info"
        >
            <Alert
                v-if="
                    channelItem &&
                    channelItem.attach &&
                    channelItem.attach.isAccountPay === 1
                "
                class="margin-top-15 margin-left-20 margin-right-20 font-bold"
                type="error"
            >
                {{
                    $t("erp.b2c.logistics_tip", {
                        defaultValue:
                            "小贴士：本订单运费由平台支付，请使用Third Party来打印面单！",
                    })
                }}
                <span
                    v-if="channelItem.attach && channelItem.attach.remark"
                    style="color: red"
                    >({{ channelItem.attach.remark }})</span
                >
            </Alert>
            <compFormQuery
                v-if="type === 'query'"
                class="margin-right-15 margin-top-15"
                :formdata="getLogistic"
                :value="formData"
                placeholder="--"
            ></compFormQuery>
            <compFormEdit
                v-else
                ref="tableEdit2"
                class="margin-right-15 margin-top-15 editorderform"
                :formdata="getLogistic"
                v-model="formData"
            ></compFormEdit>
        </compWrapper>
        <compWrapper
            v-if="dataListAttach.length > 0"
            :title="$t('global.common.attache', { defaultValue: '附件信息' })"
            theme="info"
        >
            <Table
                class="table-margin"
                :columns="columnsAttach"
                :data="dataListAttach"
                size="small"
                ref="table"
                border
                stripe
            ></Table>
        </compWrapper>
        <compWrapper
            v-if="dataListPallet.length > 0"
            :title="
                $t('erp.b2c.trust_information', { defaultValue: '打托信息' })
            "
            theme="info"
        >
            <Table
                class="table-margin"
                :columns="columnsPallet"
                :data="dataListPallet"
                size="small"
                ref="table"
                border
                stripe
            ></Table>
        </compWrapper>
        <compWrapper
            v-if="dataListPackage.length > 0"
            :title="
                $t('erp.b2c.parcel_information', { defaultValue: '包裹信息' })
            "
            theme="info"
        >
            <Table
                class="table-margin"
                :columns="columnsPackage"
                :data="dataListPackage"
                size="small"
                ref="table"
                border
                stripe
            ></Table>
        </compWrapper>
        <compWrapper
            v-if="cartonItem.length > 0"
            :title="$t('erp.b2c.box_details', { defaultValue: '箱明细' })"
            theme="info"
        >
            <Table
                class="table-margin"
                :columns="cartonItemPackage"
                :data="cartonItem"
                size="small"
                ref="table"
                border
                stripe
                :loading="cartonLoading"
            ></Table>
            <!-- 分页组件 -->
            <Page
                :current="currentPage"
                :total="totalItems"
                :page-size="pageSize"
                @on-change="handlePageChange"
                show-total
                show-elevator
                style="margin-top: 15px; text-align: right; margin-right: 15px"
            />
        </compWrapper>
        <compPhotoLog v-if="type === 'query'" v-bind="photoData"></compPhotoLog>
        <compWrapper
            v-if="type === 'query'"
            :title="
                $t('erp.distribution.operation', { defaultValue: '操作记录' })
            "
            theme="info"
        >
            <compLog :data="dataListLog" :columns="columnsLog"></compLog>
        </compWrapper>
        <vLoading v-if="loading" loading fix />
        <compModal
            v-model="confirmModal.show"
            v-bind="confirmModal"
            @on-close="handleConfirmModalClose"
        >
        </compModal>
        <compModal
            class="hidefooter"
            v-model="handle.show"
            :mask-closable="false"
            v-bind="handle"
            @on-close="handleModalClose"
        >
            <component
                :is="handle.component"
                @on-close="handleModalClose"
                @on-update="update"
                v-bind="handle"
            ></component>
            <footer slot="footer" v-show="handle.footer"></footer>
        </compModal>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-confirm="modalProps = {}"
            @on-close="modalProps = {}"
        >
            <component
                ref="cusref"
                :is="modalProps.component"
                v-bind="modalProps"
                @on-close="modalProps = {}"
                v-on="modalProps.on"
            ></component>
        </compModal>
        <Spin v-if="loading" fix></Spin>
        <AlertComp
            :show="alertProps.show"
            v-bind="alertProps"
            @on-alert-close="closeAlertModal"
        ></AlertComp>
        <!-- <Spin v-if="loading1" fix class="fuck">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>测算中</div>
    </Spin> -->
        <vLoading size="large" transfer :loading="loading1">
            <Icon
                type="ios-loading"
                size="18"
                class="demo-spin-icon-load"
            ></Icon>
            <div>
                {{
                    $t("erp.b2c.process_calculation", {
                        defaultValue: "测算中",
                    })
                }}
            </div>
        </vLoading>
    </div>
</template>

<script>
import AlertComp from "../alert";
import {
    HttpGetDistributionOne,
    HttpDeleteAttchment,
    HttpPickUp,
    HttpEditOne,
    HttpRecoverNormal,
    HttpResubmit,
    HttpResetOrder,
    HttpCalculate,
    HttpCreateTruck,
    HttpGetPalletList,
    HttpPoShipmentCartonItem,
} from "@/service/boss/distribution";
import {
    HttpGetStates,
    HttpGetOrgWarehouseCode,
    HttpGetCarrierCusList,
} from "@/service/boss/b2corder";
import { HttpWarehouseAllList } from "@mods/service/dictionary";
import { HttpGetContry } from "@/service/boss/dictionary";
import { mapState, mapGetters } from "vuex";
import mixinList from "./../mixin";
import comAttacheupload from "./attachementupload.vue";
import compManualBack from "./manualback.vue";
import compExportAmzcc from "./exportamzcc.vue";
import compPoUpload from "./poupload.vue";
import compSkuChangeLabel from "./skuChangeLabel.vue";
import compLog from "@components/templates/log";
import compAddNotes from "./addnotes";
import comCancel from "./cancel";
import compSendTime from "./sendtime";
import comBuyFaceOrder from "./buyfaceorder";
export default {
    props: ["activeid", "querytype"],
    mixins: [mixinList],
    components: {
        compModal: () => import("@components/templates/modal"),
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog,
        comAttacheupload,
        compManualBack,
        compExportAmzcc,
        compPoUpload,
        AlertComp,
        compAddNotes,
        comCancel,
        compSendTime,
        comBuyFaceOrder,
        compSkuChangeLabel,
    },
    data() {
        return {
            contextId: global.SYSID,
            id: this.activeid ? this.activeid : this.$route.query.id,
            type: this.querytype ? this.querytype : this.$route.params.type,
            loading: true,
            currentPage: 1, // 当前页码
            pageSize: 10, // 每页显示条数
            totalItems: 0, // 总数据量(从后端获取)
            cartonItem: [], // 当前页数据
            cartonLoading: false, // 加载状态
            formData: {},
            dataListLog: [],
            dataList: [],
            dataListPackage: [],
            dataListAttach: [],
            dataListPallet: [],
            handle: {
                show: false,
            },
            confirmModal: {
                show: false,
            },
            modalProps: {},
            countries: [],
            states: [],
            shippingList: [],
            loading1: false,
            alertProps: {
                show: false,
            },
            channelItem: {},
            closeEdit: false,
            photoData: {},
            disableChargeAccNo: false,
            disableCarrier: false,
            ourCarrierList: [],
            warehouseList: [],
        };
    },
    watch: {
        activeid: {
            immediate: true,
            handler(val) {
                this.loading = true;
                this.id = val ? val : this.$route.query.id;
                this.update();
            },
        },
    },
    created() {
        this.getWarehouseList();
        this.deliverset = this.handleAuth("deliver.order.set");
        this.delivercancel = this.handleAuth("deliver.order.cancel");
        this.deliverBuyLabel = this.handleAuth("deliver.order.buylabel");
        // console.log(this.id, this.type);
        this.contextId = global.SYSID;
        this.update();
    },
    computed: {
        ...mapGetters("diction", [
            "getNewAllProductList",
            "getNewAllAccountIdList",
        ]),
        //...mapGetters('diction', ['getNewProductList', 'getNewWarehouseIdList']),
        ...mapGetters("dictionary", [
            "getOrgList",
            "getNewAllWarehouseIdList",
            "getCarrierCusList",
        ]),
        ...mapState("boss", ["sysshippingcode"]),
        orgWarehouseAll() {
            //console.log(_this.orderOrgId)
            let arr = this.warehouseList.filter((item) => {
                return (
                    item.attach.warehouseType != 4 &&
                    item.attach.orgId == this.formData.orgId
                );
            });
            // console.log(arr);
            return arr;
        },
        getBase() {
            return [
                {
                    label: this.$t("erp.distribution.deliverorderno", {
                        defaultValue: "配货单号",
                    }),
                    key: "deliverOrderNo",
                    show: this.type != "add",
                },
                {
                    label: this.$t("global.common.status", {
                        defaultValue: "状态",
                    }),
                    render: (h) => {
                        let result = this.getStatus(
                            this.formData.deliverOrderStatus
                        );
                        let resultLabel = result ? result.label : "--";
                        return (
                            <div style="display: flex;">
                                <Button class={result ? result.color : ""}>
                                    {resultLabel}
                                </Button>
                                <div
                                    class="b2cfont-italic b2ccolor-info margin-left-15"
                                    style={
                                        this.formData.isSfp
                                            ? ""
                                            : "display: none"
                                    }
                                >
                                    Prime
                                </div>
                            </div>
                        );
                    },
                },
                {
                    label: this.$t("erp.b2c.search_ordernumber", {
                        defaultValue: "订单号",
                    }),
                    render: (h) => {
                        return (
                            <div>
                                {this.formData.sourceId}/
                                {this.formData.sourceNo}
                            </div>
                        );
                    },
                },
                {
                    label: this.$t("erp.product.product_line", {
                        defaultValue: "项目",
                    }),
                    render: (h) => {
                        let productItem =
                            this.getNewAllProductList.filter((item) => {
                                return item.value === this.formData.lineId;
                            })[0] || {};
                        return <div>{productItem.label}</div>;
                    },
                },
                {
                    label: this.$t("erp.b2c.channel_account", {
                        defaultValue: "渠道账号",
                    }),
                    render: (h) => {
                        // console.log(this.channelItem);
                        // let dataItem = this.getNewAllAccountIdList.filter(
                        //     (item) => {
                        //         return item.value === this.formData.channelId;
                        //     }
                        // )[0];
                        return (
                            <div>
                                {this.channelItem && this.channelItem.attach
                                    ? `${this.channelItem.attach.title}(${this.channelItem.attach.flag})`
                                    : "--"}
                            </div>
                        );
                    },
                },
                {
                    label: this.$t("global.common.createdtime", {
                        defaultValue: "创建时间",
                    }),
                    key: "createdAt",
                },
                {
                    show: this.contextId == 1000147,
                    label: this.$t("erp.distribution.ispickup", {
                        defaultValue: "是否可提货",
                    }),
                    key: "pickup",
                    render: (h) => {
                        const statusObj = {
                            1: this.$t("erp.distribution.pickup", {
                                defaultValue: "是",
                            }),
                            0: this.$t("erp.distribution.nopickup", {
                                defaultValue: "否",
                            }),
                        };
                        return (
                            <div>{statusObj[this.formData.pickupStatus]}</div>
                        );
                    },
                },
                // {
                //     label: '总金额',
                //     key: ''
                // },
            ];
        },
        getRecive() {
            return [
                {
                    label: this.$t("erp.b2c.recipients", {
                        defaultValue: "收件人",
                    }),
                    key: "shipToContact",
                },
                {
                    label: this.$t("erp.b2c.state_province", {
                        defaultValue: "州/省份",
                    }),
                    key: "shipToState",
                    render: (h) => {
                        return (
                            <div>
                                {this.formData.shipToState
                                    ? this.formData.shipToState
                                    : "--"}
                            </div>
                        );
                    },
                    tag: "vSelect",
                    options: this.states,
                    props: {
                        filterable: true,
                    },
                    required: false,
                },
                {
                    label: this.$t("erp.b2border.addressone", {
                        defaultValue: "地址1",
                    }),
                    key: "shipToAddress1",
                },
                {
                    label: this.$t("erp.product.country_code", {
                        defaultValue: "国家编码",
                    }),
                    key: "shipToCountry",
                    render: (h) => {
                        return (
                            <div>
                                {this.formData.shipToCountry
                                    ? this.formData.shipToCountry
                                    : "--"}
                            </div>
                        );
                    },
                    tag: "vSelect",
                    options: this.countries,
                    props: {
                        filterable: true,
                    },
                    on: {
                        "on-change": (val) => {
                            let item = this.countries.filter((item) => {
                                return item.value === val;
                            })[0];
                            this.getState(item.id);
                        },
                    },
                },
                {
                    label: this.$t("erp.b2border.addresstwo", {
                        defaultValue: "地址2",
                    }),
                    key: "shipToAddress2",
                    required: false,
                },
                {
                    label: this.$t("erp.b2c.zip_code", {
                        defaultValue: "邮编",
                    }),
                    key: "shipToPostal",
                },
                // {
                //     label: '地址3',
                //     key: ''
                // },
                {
                    label: this.$t("erp.b2c.city", { defaultValue: "城市" }),
                    key: "shipToCity",
                },
                {
                    label: this.$t("erp.b2c.phone", { defaultValue: "电话" }),
                    required: false,
                    key: "shipToMobile",
                },
                {
                    label: this.$t("erp.b2c.address_type", {
                        defaultValue: "地址类型",
                    }),
                    required: false,
                    query: true,
                    key: "addressLabel",
                },
                {
                    label: this.$t("erp.b2c.customers_email", {
                        defaultValue: "客户邮箱",
                    }),
                    query: true,
                    required: false,
                    key: "customerEmail",
                },
            ];
        },
        columns() {
            return [
                {
                    title: "Seller SKU",
                    key: "sellerSku",
                    render: (h, { row }) => {
                        return (
                            <div>{row.sellerSku ? row.sellerSku : "--"}</div>
                        );
                    },
                },
                {
                    title: "ERP SKU",
                    key: "erpsku",
                },
                {
                    title: this.$t("global.common.quantity", {
                        defaultValue: "数量",
                    }),
                    key: "qty",
                },
                {
                    title:
                        this.$t("global.common.length", {
                            defaultValue: "长",
                        }) + "(cm)",
                    key: "length",
                },
                {
                    title:
                        this.$t("global.common.width", { defaultValue: "宽" }) +
                        "(cm)",
                    key: "width",
                },
                {
                    title:
                        this.$t("global.common.height", {
                            defaultValue: "高",
                        }) + "(cm)",
                    key: "height",
                },
                {
                    title:
                        this.$t("global.common.weight", {
                            defaultValue: "重量",
                        }) + "(g)",
                    key: "weight",
                },
            ];
        },
        getLogistic() {
            return [
                {
                    label: this.$t("global.common.deliveryWarehouse", {
                        defaultValue: "发货仓库",
                    }),
                    tag: "vSelect",
                    key: "orgWarehouseId",
                    options: this.orgWarehouseAll,
                    props: {
                        filterable: true,
                    },
                    render: (h) => {
                        let dataItem = this.orgWarehouseAll.filter((item) => {
                            return item.value == this.formData.orgWarehouseId;
                        })[0];
                        return <div>{dataItem ? dataItem.label : "--"}</div>;
                    },
                    on: {
                        "on-change": (val) => {
                            let dataItem = this.orgWarehouseAll.filter(
                                (item) => {
                                    return item.value === val;
                                }
                            )[0];
                            this.getwarehouseCarry(dataItem.attach.code);
                        },
                    },
                },
                {
                    label: this.$t("erp.distribution.isship", {
                        defaultValue: "是否加急",
                    }),
                    query: true,
                    tag: "div",
                    // key: 'systemShipServiceLevel',
                    children: (h) => {
                        return (
                            <div>
                                {this.formData.systemShipServiceLevel === 1
                                    ? this.$t("erp.global.yes", {
                                          defaultValue: "是",
                                      })
                                    : this.$t("erp.global.no", {
                                          defaultValue: "否",
                                      })}
                            </div>
                        );
                    },
                    render: (h) => {
                        return (
                            <div>
                                {this.formData.systemShipServiceLevel === 1
                                    ? this.$t("erp.global.yes", {
                                          defaultValue: "是",
                                      })
                                    : this.$t("erp.global.no", {
                                          defaultValue: "否",
                                      })}
                            </div>
                        );
                    },
                },
                {
                    label: this.$t("erp.distribution.cusseivice", {
                        defaultValue: "发货方式",
                    }),
                    key: "customerCarrierServiceCode",
                    tag: "Select",
                    options: this.shippingList,
                    props: {
                        filterable: true,
                    },
                    render: (h) => {
                        return (
                            <div>
                                {this.formData.customerCarrierServiceCode
                                    ? this.formData.customerCarrierServiceCode
                                    : "--"}
                            </div>
                        );
                    },
                },
                // {
                //   labelWidth: 0,
                //   key: "carrierAccountGroupId",
                //   tag: "Select",
                //   options: this.ourCarrierList,
                //   span: 6,
                //   props: {
                //     filterable: true,
                //     style: "height:32px",
                //   },
                //   show: this.type != 'query',
                // },
                {
                    label: this.$t("erp.b2c.Pickup_time", {
                        defaultValue: "提货时间",
                    }),
                    key: "pickupTime",
                    query: true,
                },
                {
                    label: this.$t("erp.b2c.latest_time", {
                        defaultValue: "最晚发货时间",
                    }),
                    key: "latestShipDate",
                    query: true,
                },
                {
                    label: this.$t("erp.b2c.3rd_account", {
                        defaultValue: "3rd账号",
                    }),
                    tag: "Input",
                    key: "thirdPartyAccount",
                    required: false,
                    props: {
                        clearable: true,
                    },
                    render: (h) => {
                        return (
                            <div>
                                {this.formData.thirdPartyAccount
                                    ? this.formData.thirdPartyAccount
                                    : "--"}
                            </div>
                        );
                    },
                },
                {
                    label: "ZONE",
                    key: "warehouseZone",
                    query: true,
                },
                {
                    label: this.$t("erp.b2c.whether_insured", {
                        defaultValue: "是否投保",
                    }),
                    key: "isInsure",
                    tag: "vRadio",
                    required: false,
                    options: this.getYesArray,
                    render: (h) => {
                        return (
                            <div>
                                {this.formData.isInsure === 1
                                    ? this.$t("erp.global.yes", {
                                          defaultValue: "是",
                                      })
                                    : this.$t("erp.global.no", {
                                          defaultValue: "否",
                                      })}
                            </div>
                        );
                    },
                },
                {
                    label: this.$t("erp.product.insured_price_only", {
                        defaultValue: "投保金额",
                    }),
                    required: false,
                    key: "insureAmount",
                },
                {
                    label: this.$t("erp.distribution.issignature", {
                        defaultValue: "是否签收",
                    }),
                    required: false,
                    key: "isSignature",
                    tag: "vRadio",
                    options: this.getYesArray,
                    render: (h) => {
                        return (
                            <div>
                                {this.formData.isSignature === 1
                                    ? this.$t("erp.global.yes", {
                                          defaultValue: "是",
                                      })
                                    : this.$t("erp.global.no", {
                                          defaultValue: "否",
                                      })}
                            </div>
                        );
                    },
                },
                {
                    label: this.$t("erp.b2c.estimate_costs", {
                        defaultValue: "预估物流费",
                    }),
                    key: "estimateShipCost",
                    query: true,
                },
                {
                    label: this.$t(
                        "erp.distribution.warehouse_expect_lastest_time",
                        {
                            defaultValue: "仓库预计发货时间",
                        }
                    ),
                    key: "warehouseLastOutboundDate",
                    query: true,
                },
                {
                    label: "ARN",
                    key: "arn",
                    query: true,
                },
                {
                    label: this.$t("fbb.headlogistics.total_weight", {
                        defaultValue: "总重量",
                    }),
                    key: "totalWeight",
                    query: true,
                    render: (h) => {
                        return (
                            <div>
                                {this.formData.totalWeight
                                    ? this.weightInKg(
                                          this.formData.totalWeight
                                      ) + " kg"
                                    : "--"}
                            </div>
                        );
                    },
                },
                {
                    label: this.$t("fbb.headlogistics.total_volumn", {
                        defaultValue: "总体积",
                    }),
                    key: "totalVolume",
                    query: true,
                    render: (h) => {
                        return (
                            <div>
                                {this.formData.totalVolume
                                    ? this.volumeInCubicMeters(
                                          this.formData.totalVolume
                                      ) + " m³"
                                    : "--"}
                            </div>
                        );
                    },
                },
                {
                    label: this.$t("fbb.inbound.total_cases", {
                        defaultValue: "总箱数",
                    }),
                    key: "totalCarton",
                    query: true,
                },
            ];
        },
        columnsPallet() {
            return [
                {
                    title: this.$t("fbb.transfer.panelno", {
                        defaultValue: "托盘NO",
                    }),
                    key: "palletBarcode",
                    render: (h, { row }) => {
                        return <div>{row.palletBarcode || "--"}</div>;
                    },
                    width: 120,
                },
                {
                    title:
                        this.$t("fbb.truck.palletsize", {
                            defaultValue: "托盘尺寸",
                        }) + "(inch)",
                    key: "palletLength",
                    render: (h, { row }) => {
                        return (
                            <div>
                                {row.palletLength}*{row.palletWidth}*
                                {row.palletHeight}
                            </div>
                        );
                    },
                    width: 120,
                },
                {
                    title:
                        this.$t("fbb.transfer.palletweight", {
                            defaultValue: "托盘重量",
                        }) + "(lb)",
                    key: "palletWeight",
                    render: (h, { row }) => {
                        return <div>{row.palletWeight || 0}</div>;
                    },
                    width: 120,
                },
                {
                    title: "SKU",
                    key: "sku",
                    render: (h, { row }) => {
                        return <div>{row.sku || "--"}</div>;
                    },
                },
                {
                    title: this.$t("fbb.transfer.palletamount", {
                        defaultValue: "数量/托",
                    }),
                    key: "qty",
                    render: (h, { row }) => {
                        return <div>{row.qty || 0}</div>;
                    },
                    width: 80,
                },
                {
                    title: this.$t("global.common.update_time", {
                        defaultValue: "更新时间",
                    }),
                    key: "updatedAt",
                    render: (h, { row }) => {
                        return <div>{row.updatedAt || "--"}</div>;
                    },
                },
            ];
        },
        columnsAttach() {
            return [
                {
                    title: this.$t("erp.b2c.attachment_type", {
                        defaultValue: "附件类型",
                    }),
                    key: "type",
                },
                {
                    title: this.$t("global.common.attachment_name", {
                        defaultValue: "附件名称",
                    }),
                    render: (h, { row }) => {
                        return (
                            <div>
                                <a
                                    type="primary"
                                    size="small"
                                    on-click={() => window.open(row.url)}
                                >
                                    {row.name}
                                </a>
                            </div>
                        );
                    },
                },
                {
                    width: 100,
                    title: this.$t("global.common.operation", {
                        defaultValue: "操作",
                    }),
                    render: (h, { row }) => {
                        // if (row.module === "ORDER") {
                        //     return <div></div>;
                        // }
                        // console.log(row);
                        return (
                            <div>
                                <Button
                                    class="light-content"
                                    size="small"
                                    type="default"
                                    on-click={this.deleteAttach.bind(
                                        this,
                                        row.id
                                    )}
                                >
                                    {this.$t("global.common.delete", {
                                        defaultValue: "删除",
                                    })}
                                </Button>
                            </div>
                        );
                    },
                },
            ];
        },
        columnsPackage() {
            return [
                {
                    title: "Tracking",
                    key: "trackNo",
                    render: (h, { row }) => {
                        if (
                            row.packageUrl &&
                            this.handleAuth("deliver.order.label")
                        ) {
                            return h(
                                "a",
                                {
                                    attrs: {
                                        href: row.packageUrl,
                                        target: "_blank",
                                    },
                                },
                                row.trackNo
                            );
                        } else return <div>{row.trackNo}</div>;
                    },
                },
                {
                    title: this.$t("erp.b2c.package_logistics_status", {
                        defaultValue: "物流状态",
                    }),
                    //key: 'logisticStatus'
                    render: (h, { row }) => {
                        let status =
                            row.logisticStatus == undefined
                                ? -1
                                : row.logisticStatus;
                        let dataItem = this.packStatus.filter((item) => {
                            return item.value === status;
                        })[0];
                        return <div>{dataItem ? dataItem.label : "--"}</div>;
                    },
                },
                {
                    title: "ERP SKU",
                    key: "erpSku",
                },
                {
                    title: this.$t("erp.b2c.quantity_shipped", {
                        defaultValue: "发货数量",
                    }),
                    key: "shipedQuantity",
                },
                {
                    title: this.$t("erp.b2c.shipping_method", {
                        defaultValue: "发货方式",
                    }),
                    key: "serviceCode",
                },
                {
                    title: this.$t("erp.b2c.search_outtime", {
                        defaultValue: "发货时间",
                    }),
                    key: "shipmentDate",
                },
            ];
        },
        cartonItemPackage() {
            const allColumns = [
                {
                    title: this.$t("fbb.inbound.case_code", {
                        defaultValue: "箱码",
                    }),
                    render: (h, { row }) => {
                        return (
                            <div style="font-weight: 700;">
                                {row.cartonNo || "--"}
                            </div>
                        );
                    },
                },
                {
                    title: "ASIN",
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>
                                    ASIN：
                                    <span style="font-weight: 700;">
                                        {row.asin || "--"}
                                    </span>
                                </div>
                                <div>
                                    SELLER SKU：
                                    <span style="font-weight: 700;">
                                        {row.sellerSku || "--"}
                                    </span>
                                </div>
                            </div>
                        );
                    },
                },
                {
                    title: "ERP SKU",
                    width: 120,
                    render: (h, { row }) => {
                        return <div>{row.erpsku || "--"}</div>;
                    },
                },
                {
                    title: this.$t("erp.b2c.number", {
                        defaultValue: "数量",
                    }),
                    key: "qty",
                    width: 80,
                },
                {
                    title: this.$t("tms.ship.state", {
                        defaultValue: "状态",
                    }),
                    key: "status",
                    width: 100,
                    render: (h, { row }) => {
                        if (row.status == 0) {
                            return (
                                <div>
                                    {this.$t("erp.b2c.Not_pushed", {
                                        defaultValue: "未推送",
                                    })}
                                </div>
                            );
                        } else if (row.status == 1) {
                            return (
                                <div>
                                    {this.$t("erp.distribution.pushed", {
                                        defaultValue: "已推送",
                                    })}
                                </div>
                            );
                        } else if (row.status == 2) {
                            return (
                                <div>
                                    {this.$t("erp.b2c.orderstatus_shipped", {
                                        defaultValue: "已发货",
                                    })}
                                </div>
                            );
                        } else if (row.status == 3) {
                            return (
                                <div>
                                    {this.$t("erp.distribution.pusherror", {
                                        defaultValue: "推送异常",
                                    })}
                                </div>
                            );
                        } else if (row.status == 4) {
                            return (
                                <div>
                                    {this.$t("fbb.inbound.error_receive", {
                                        defaultValue: "回传异常",
                                    })}
                                </div>
                            );
                        } else {
                            return <div>--</div>;
                        }
                    },
                },
                {
                    title: this.$t("erp.b2c.Volume_Weight", {
                        defaultValue: "体积/重量",
                    }),
                    width: 160,
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>
                                    volume：
                                    {row.volume
                                        ? this.volumeInCubicMeters(row.volume) +
                                          " m³"
                                        : "--"}
                                </div>
                                <div>
                                    weight：
                                    {row.weight
                                        ? this.weightInKg(row.weight) + " kg"
                                        : "--"}
                                </div>
                            </div>
                        );
                    },
                },
                {
                    title: "Tracking No",
                    width: 140,
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>{row.trackingNo || "--"}</div>
                            </div>
                        );
                    },
                },
                {
                    title: "Label",
                    render: (h, { row }) => {
                        return (
                            <span>
                                <a
                                    type="primary"
                                    size="small"
                                    on-click={() =>
                                        row.cartonLabel
                                            ? window.open(row.cartonLabel)
                                            : null
                                    }
                                    style={{
                                        cursor: row.cartonLabel
                                            ? "pointer"
                                            : "default",
                                    }}
                                >
                                    {row.cartonLabel ? "Carton Label" : "--"}
                                </a>
                                /
                                <a
                                    type="primary"
                                    size="small"
                                    on-click={() =>
                                        row.shippingLabel
                                            ? window.open(row.shippingLabel)
                                            : null
                                    }
                                    style={{
                                        cursor: row.shippingLabel
                                            ? "pointer"
                                            : "default",
                                    }}
                                >
                                    {row.shippingLabel
                                        ? "Shipping Label"
                                        : "--"}
                                </a>
                            </span>
                        );
                    },
                },
            ];

            // 根据条件决定是否显示某些列
            return allColumns.filter((column) => {
                if (
                    column.key === "status" &&
                    this.formData.customerCarrierServiceCode === "FBA-LTL"
                ) {
                    return false; // 不显示状态列
                }
                return true; // 显示其他列
            });
        },
        columnsLog() {
            return [
                {
                    title: this.$t("global.log.operator", {
                        defaultValue: "操作人",
                    }),
                    key: "createdName",
                },
                {
                    title: this.$t("global.log.date", {
                        defaultValue: "操作时间",
                    }),
                    key: "createdAt",
                },
                {
                    title: this.$t("global.log.operalog", {
                        defaultValue: "操作日志",
                    }),
                    key: "message",
                },
            ];
        },
        getYesArray() {
            return [
                {
                    label: this.$t("erp.global.yes", { defaultValue: "是" }),
                    trueValue: 1,
                },
                {
                    label: this.$t("erp.global.no", { defaultValue: "否" }),
                    trueValue: 0,
                },
            ];
        },
        getServiceCode() {
            return this.sysshippingcode.map((item) => {
                return {
                    value: item,
                    label: item,
                };
            });
        },
    },
    methods: {
        weightInKg(weight) {
            return (weight / 1000).toFixed(2);
        },
        volumeInCubicMeters(volume) {
            const result = volume / 1000000;
            // 先保留6位小数，然后用parseFloat去除末尾的0
            return parseFloat(result.toFixed(6));
        },
        getWarehouseList() {
            HttpWarehouseAllList().then(
                (res) => {
                    this.warehouseList = res.data.map((item) => ({
                        value: item.id,
                        label: `${item.code}(${item.title})`,
                        attach: {
                            code: item.code,
                            warehouseType: item.warehouseType,
                            orgId: item.organizationId,
                            apiType: item.apiType,
                        },
                    }));
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        handleConfirmModalClose() {
            this.$emit("on-openCloseable");
            this.confirmModal.show = false;
        },
        handleModalClose() {
            // console.log('关闭', 456);
            this.$emit("on-openCloseable");
            this.handle.show = false;
        },
        handleModalShow() {
            // console.log('开启', 123);
            this.$emit("on-closeCloseable");
        },
        handleMore(name) {
            // this.handleModalShow();
            switch (name) {
                // 添加备注
                case "addNotes":
                    this.addNotes();
                    break;
                // 推送仓库
                case "pushWarehouse":
                    this.handleAlert("pushWarehouse");
                    break;
                // 附件重推
                case "pushAgain":
                    this.handleAlert("pushAgain");
                    break;
                // 附件上传
                case "attachUpload":
                    this.attachUpload();
                    break;
                // 购买面单
                case "buyLabel":
                    this.buyLabel();
                    break;
                // 重新提交
                case "resubmit":
                    this.handleAlert("resubmit");
                    break;
                // 取消
                case "cancel":
                    // console.log('取消Id', this.formData.id);
                    // console.log(this.activeid, this.id);
                    this.cancelOrder();
                    break;
                // 修改最晚发货时间
                case "batchChangeLastestTime":
                    this.changeLastestTime();
                    break;
            }
        },
        changeLastestTime() {
            this.handle = {
                show: true,
                title: this.$t(
                    "erp.distribution.batch_change_lastest_deliver_date",
                    { defaultValue: "修改最晚发货时间" }
                ),
                width: 460,
                showFooter: false,
                activeids: this.id ? this.id : this.activeid,
                component: "compSendTime",
            };
        },
        addNotes() {
            this.handle = {
                title: this.$t("erp.b2c.add_notes", {
                    defaultValue: "添加备注",
                }),
                show: true,
                activeids: this.id ? this.id : this.activeid,
                width: 600,
                component: "compAddNotes",
                showFooter: false,
            };
        },
        cancelOrder() {
            this.handle = {
                title: this.$t("global.common.operate_cancel", {
                    defaultValue: "取消",
                }),
                show: true,
                activeid: this.id ? this.id : this.activeid,
                width: 600,
                component: "comCancel",
                showFooter: false,
            };
        },
        closeAlertModal() {
            this.$emit("on-openCloseable");
            this.alertProps.show = false;
        },
        handleAlert(type) {
            switch (type) {
                case "pushWarehouse":
                    this.alertProps = {
                        show: true,
                        title: this.$t("erp.b2c.pushyuncang", {
                            defaultValue: "推送仓库",
                        }),
                        desc: this.$t("erp.b2c.pushyuncang_alert"),
                        confirm: () => {
                            this.pushWarehouse(this.id, () => {
                                this.alertProps.show = false;
                            });
                        },
                    };

                    // console.log("执行了推送仓库", this.alertProps.show);
                    break;
                case "pushAgain":
                    this.alertProps = {
                        show: true,
                        title: this.$t("erp.distribution.repush", {
                            defaultValue: "附件重推",
                        }),
                        desc: this.$t("erp.distribution.pushfile_alert"),
                        confirm: () => {
                            this.pushAgain(this.id, () => {
                                this.alertProps.show = false;
                            });
                        },
                    };
                    break;
                case "backToNormal":
                    this.alertProps = {
                        show: true,
                        title: this.$t("erp.b2c.back_normal", {
                            defaultValue: "恢复正常",
                        }),
                        desc: this.$t("erp.b2c.back_normal_alert"),
                        confirm: () => {
                            this.backToNormal();
                        },
                    };
                    break;
                case "resubmit":
                    this.alertProps = {
                        show: true,
                        title: this.$t("global.common.resubmit", {
                            defaultValue: "重新提交",
                        }),
                        desc: this.$t("erp.distribution.resubmit_alert"),
                        confirm: () => {
                            this.resubmit();
                        },
                    };
                    break;
                case "reset":
                    this.alertProps = {
                        show: true,
                        title: this.$t("erp.disturibution.reset_order", {
                            defaultValue: "重置配货单",
                        }),
                        desc: this.$t("erp.disturibution.reset_order_alert"),
                        confirm: () => {
                            HttpResetOrder({
                                deliverOrderIds: this.id,
                            }).then(
                                (res) => {
                                    this.$VMessage.success(res.message);
                                    this.alertProps.show = false;
                                },
                                (err) => {
                                    this.$VMessage.error({
                                        content: err.message,
                                        duration: 30,
                                        closable: true,
                                    });
                                    this.alertProps.show = false;
                                }
                            );
                        },
                    };
                    break;
            }
        },
        editOrder() {
            this.loading = true;
            this.type = "edit";
            this.closeEdit = true;
            this.update();
        },
        async getwarehouseCarry(value) {
            // console.log("仓库code", value);
            let aaa = [
                { label: "YRC", value: "YRC" },
                { label: "Australia Post", value: "Australia Post" },
                { label: "Other", value: "Other" },
            ];
            if (!value) return (this.shippingList = aaa);
            await HttpGetOrgWarehouseCode({
                orgId: global.SYSID,
                warehouseCode: value,
            }).then(
                (res) => {
                    let dataArr = [];
                    if (res.data) {
                        dataArr = res.data.map((item) => {
                            return {
                                label: `${item.code}(${item.carrierServiceName})`,
                                value: item.code,
                                attach: {
                                    ...item,
                                },
                            };
                        });
                    }
                    this.shippingList = dataArr;
                    this.shippingList = this.shippingList.concat(aaa);
                    this.shippingList = this.arrayUnique(
                        this.shippingList,
                        "value"
                    );
                    // console.log("发货方式列表", shippingList);
                    // console.log(res)
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                    this.shippingList = aaa;
                }
            );
        },
        // 数组去重
        arrayUnique(arr, name) {
            var hash = {};
            return arr.reduce((item, next) => {
                hash[next[name]]
                    ? ""
                    : (hash[next[name]] = true && item.push(next));
                return item;
            }, []);
        },
        async getCountry() {
            await HttpGetContry({
                "search[EQ_depth]": 2,
            }).then(
                (res) => {
                    this.countries = res.data.map((item) => {
                        return {
                            value: item.code,
                            label: `${item.code} (${item.nameEn})`,
                            id: item.id,
                            attach: {
                                ...item,
                            },
                        };
                    });
                },
                (err) => {
                    // console.log(err);
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
            // console.log("国家列表", this.countries);
        },
        async getState(code) {
            this.states = [];
            await HttpGetStates({
                "search[EQ_depth]": 4,
                "search[EQ_parentId]": code,
            }).then(
                (res) => {
                    let array = res.data;
                    array.map((item) => {
                        this.states.push(item.code);
                    });
                    // console.log(this.states)
                },
                (err) => {}
            );
        },
        getError() {
            if (this.formData.errorCode === 0) return "";
            let item = this.distributionException.filter((item) => {
                return item.value == this.formData.errorCode;
            })[0];
            if (!item) return;
            return item.label;
        },
        refresh() {
            this.loading = true;
            this.update();
        },
        pickup() {
            this.confirmModal = {
                show: true, //显示弹框
                width: 500, //弹框宽度
                alert: "error", //简洁模式主题和component模式互斥，
                params: {
                    contextId: this.contextId,
                    deliverOrderIds: [this.id ? this.id : this.activeid],
                }, //接口参数
                ajaxRequest: HttpPickUp, //接口
                desc: this.$t("erp.distribution.pickup_modal_desc", {
                    defaultValue: "Are you sure to pickup?",
                }),
                showDesc: true, //不显示描述，
                title: this.$t("erp.distribution.pickup_modal_title", {
                    defaultValue: "Pickup",
                }), //标题，
                callback: (res) => {
                    if (res.statusCode === 200) {
                        this.$VMessage.success(res.message);
                        this.update();
                    } else {
                        this.$VMessage.error({
                            content: res.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                },
            };
        },
        attachUpload() {
            this.handleModalShow();
            this.handle = {
                title: this.$t("erp.b2c.arrachement_upload", {
                    defaultValue: "附件上传",
                }),
                show: true,
                activeids: this.id ? this.id : this.activeid,
                width: 1000,
                component: "comAttacheupload",
                showFooter: false,
            };
        },
        async buyLabel() {
            this.loading1 = true;
            await HttpCalculate({ deliverOrderId: this.id }).then(
                (res) => {
                    this.loading1 = false;
                    this.handleModalShow();
                    this.handle = {
                        title: this.$t("erp.aftersales.buyfaceorder", {
                            defaultValue: "购买面单",
                        }),
                        show: true,
                        activeids: this.id ? this.id : this.activeid,
                        res: res,
                        width: 600,
                        component: "comBuyFaceOrder",
                        showFooter: false,
                    };
                },
                (err) => {
                    // console.log(err);
                    this.loading1 = false;
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        deleteAttach(id) {
            // alert('删除');
            // 简洁模式
            this.confirmModal = {
                show: true, //显示弹框
                width: 500, //弹框宽度
                alert: "error", //简洁模式主题和component模式互斥，
                params: {
                    contextId: global.SYSID,
                    deliverOrderId: this.id,
                    attachmentId: id,
                }, //接口参数
                ajaxRequest: HttpDeleteAttchment, //接口
                desc: this.$t("erp.distribution.confirm_delete_attachment", {
                    defaultValue: "确定删除？",
                }),
                showDesc: true, //不显示描述，
                title: this.$t("erp.distribution.delete_attachment", {
                    defaultValue: "删除附件",
                }), //标题，
                callback: (res) => {
                    if (res.statusCode === 200) {
                        this.$VMessage.success(res.message);
                        this.update();
                    } else {
                        this.$VMessage.error({
                            content: res.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                },
            };
        },
        getStatus(type) {
            return this.distributionStatus.filter((item) => {
                return item.value === type;
            })[0];
        },
        // 获取分页数据
        async fetchCartonItems() {
            this.cartonLoading = true;
            try {
                const res = await HttpPoShipmentCartonItem({
                    deliverOrderId: this.activeid ? this.activeid : this.id,
                    page: this.currentPage,
                    rows: this.pageSize,
                    sidx: "id",
                    sord: "desc",
                });

                this.cartonItem = res.data.content || [];
                this.totalItems = res.data.totalElements || 0; // 假设后端返回总条数
            } catch (err) {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true,
                });
            } finally {
                this.cartonLoading = false;
            }
        },

        // 处理页码变化
        handlePageChange(page) {
            this.currentPage = page;
            this.fetchCartonItems(); // 获取新页码的数据
        },
        async update() {
            if (this.type === "edit") {
                this.getCountry();
                this.getState();
            }
            await HttpGetPalletList({
                deliverOrderId: this.activeid ? this.activeid : this.id,
            }).then(
                (res) => {
                    this.dataListPallet = res.data || [];
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
            this.fetchCartonItems(); // 组件创建时获取第一页数据
            // console.log(this.activeid, this.id);
            await HttpGetDistributionOne({
                deliverOrderId: this.activeid ? this.activeid : this.id,
            })
                .then(
                    (res) => {
                        this.$set(this.$data, "formData", res.data);
                        // window.console.log("this.formData", this.formData);
                        this.photoData.orderData = this.formData;
                        this.photoData.orderType = 4;
                        // this.formData = res.data;
                        this.dataList = res.data.deliverOrderItemEntityList;
                        this.dataListAttach = res.data.commonAttachmentsEntities
                            ? res.data.commonAttachmentsEntities
                            : [];
                        // let countryItem = this.countries.filter(item => {
                        //     return item.value === this.formData.shipToCountry
                        // })[0];
                        // console.log('123456', countryItem, this.formData.shipToCountry);
                        // this.getState(countryItem.id);
                        this.channelItem = this.getNewAllAccountIdList.filter(
                            (item) => {
                                return this.formData.channelId === item.value;
                            }
                        )[0];
                        let dataItem = this.orgWarehouseAll.filter((item) => {
                            return item.value === this.formData.orgWarehouseId;
                        })[0];
                        if (this.type === "edit") {
                            this.getwarehouseCarry(dataItem.attach.code);
                        }
                        // res.data.annexData == ""
                        //     ? []
                        //     : JSON.parse(res.data.annexData);
                        // this.dataListPackage =
                        //     res.data.saleShipmentPackagesList;
                        let packageList =
                            res.data.saleShipmentPackagesList.filter((item) => {
                                return item.packageFlag == 0;
                            });
                        if (!packageList.length) {
                            this.dataListPackage =
                                res.data.saleShipmentPackagesList;
                        } else {
                            this.dataListPackage = packageList;
                        }
                        this.dataListLog = res.data.deliverOrderLogEntityList;
                        this.formData.isSignature = res.data.isSignature
                            ? res.data.isSignature
                            : 0;
                        this.formData.isInsure = res.data.isInsure
                            ? res.data.isInsure
                            : 0;

                        // 请求接口下拉
                        // HttpGetCarrierCusList({
                        //   contextId: res.data.orgId,
                        // }).then(res => {
                        //   this.ourCarrierList = res.data.map(item => {
                        //     return {
                        //       value: item.id,
                        //       label: item.groupName,
                        //     }
                        //   })
                        // })
                        this.loading = false;

                        // console.log(this.formData);
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        async submit() {
            let flag = true;
            if (this.$refs.tableEdit1) {
                await this.$refs.tableEdit1.validate((valid) => {
                    flag = valid;
                });
            }
            await this.$refs.tableEdit2.validate((valid) => {
                flag = flag && valid;
            });
            if (!flag)
                return this.$VMessage.error(
                    this.$t("global.common.fill_required", {
                        defaultValue: "请填写必填项",
                    })
                );
            this.loading = true;
            await HttpEditOne(this.formData)
                .then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        if (this.closeEdit) {
                            this.closeEdit = false;
                            this.type = "query";
                            this.update();
                        } else {
                            this.cancel();
                        }
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        cancel() {
            if (this.$route.name === "distribution") {
                return this.$emit("on-close");
            }
            this.$router.push({
                name: "distribution",
            });
        },
        // 恢复正常
        async backToNormal() {
            await HttpRecoverNormal({
                deliverOrderIds: this.id,
            })
                .then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        this.update();
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                )
                .finally(() => {
                    this.alertProps.show = false;
                });
        },
        // 重新提交
        async resubmit() {
            this.loading = true;
            await HttpResubmit({
                deliverOrderIds: this.id,
            })
                .then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        this.update();
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                )
                .finally(() => {
                    this.alertProps.show = false;
                });
        },
        // 卡车预约
        async bookTruck() {
            this.handle = {
                title: this.$t("fbb.transfer.truckreservation", {
                    defaultValue: "卡车预约",
                }),
                showDesc: true,
                alert: "info",
                show: true,
                params: {
                    deliverOrderId: this.id,
                },
                ajaxRequest: HttpCreateTruck,
                callback: (res) => {
                    this.$Message.success({
                        content: res.message,
                        duration: 30,
                        closable: true,
                    });
                    this.handle.show = false;
                },
            };
        },
        // 导入打托信息
        async importTrustInfo() {
            this.modalProps = {
                show: true,
                title: this.$t("fbb.transfer.exportpaneldetail", {
                    defaultValue: "导入托盘明细",
                }),
                width: 460,
                showFooter: false,
                data: { deliverOrderId: this.id },
                action:
                    process.env.VUE_APP_APIURL_BOSS +
                    "/api/v2/DeliverOrder/palletImport",
                name: "excel",
                component: "compUpload",
                download: () => {
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_BOSS +
                            "/api/v2/DeliverOrder/palletTemplate",
                        "download"
                    );
                },
                on: {
                    "on-success": (res) => {
                        this.modalProps = {};
                        this.update();
                    },
                },
            };
        },
        // 手动回传
        async manualBack() {
            this.handleModalShow();
            this.handle = {
                show: true,
                title: this.$t("erp.b2c.manual_back", {
                    defaultValue: "手动回传",
                }),
                component: "compManualBack",
                width: 1200,
                id: this.id,
                orderData: this.formData,
                showFooter: false,
            };
            // return;
            // let {trackNo, serviceCode, } =
            // await HttpManualBack({
            //     id: this.id,
            //     contextId: global.SYSID,
            //     saleShipmentPackagesList: this.formData.saleShipmentPackagesList
            // }).then(res => {
            //     this.$VMessage.success(res.message);
            // }, err => {
            //     this.$VMessage.error(err.message);
            // }).finally(() => {
            //     this.loading = false;
            // })
        },
        // 手动回传
        async exportAmzcc() {
            this.handleModalShow();
            this.handle = {
                show: true,
                title: this.$t("erp.b2c.AMZCC_Export", {
                    defaultValue: "AMZCC导出",
                }),
                component: "compExportAmzcc",
                width: 600,
                id: this.id,
                orderData: this.formData,
                showFooter: false,
            };
        },
        // 手动回传
        async exportPoUpload() {
            this.handleModalShow();
            this.handle = {
                show: true,
                title: this.$t("erp.b2c.PO_attachments", {
                    defaultValue: "PO附件上传",
                }),
                component: "compPoUpload",
                width: 600,
                id: this.id,
                orderData: this.formData,
                showFooter: false,
            };
        },
        // 手动回传
        async skuChangeLabel() {
            this.handleModalShow();
            this.handle = {
                show: true,
                title: this.$t("erp.b2c.sku_change_label", {
                    defaultValue: "SKU换标",
                }),
                component: "compSkuChangeLabel",
                width: 1000,
                id: this.id,
                orderItemData: this.formData.deliverOrderItemEntityList,
                showFooter: false,
            };
        },
    },
};
</script>
